/**
 * Ventana compartida para marcar stale una query y limitar la restauración
 * automática de sus parámetros de navegación.
 *
 * Sale de que las ofertas del hub viajan con un `provenance` que vence a los 15
 * minutos: pasada esta ventana el resultado cacheado ya no se puede reservar.
 * El margen deja tiempo de completar una reserva sobre lo que está en pantalla.
 *
 * La marca de sessionStorage NO es frescura de cotización ni garantiza que el
 * cache exista. La autoridad reservable se calcula aparte con `dataUpdatedAt`
 * y `FARE_TTL_MS`; una URL recordada puede montar cache o una búsqueda en vivo.
 */
export const SEARCH_FRESH_MS = 12 * 60 * 1000;

/** Mayor que el anterior: el dato sobrevive mientras el agente pasea por la app. */
export const SEARCH_CACHE_MS = 20 * 60 * 1000;
